t = require('views/internal/teacup-with-helpers')('member_cards_sort')

module.exports = t.renderable ({ sort }) ->
  t.ul '.pop-over-list.checkable', ->

    t.li { class: t.classify({ 'active': sort == 'board' }) }, ->
      t.a '.highlight-icon.js-sort-by-board', { href: '#' }, ->
        t.check sort == 'board', 'sort-by-board'

    t.li { class: t.classify({ 'active': sort == 'date' }) }, ->
      t.a '.highlight-icon.js-sort-by-due-date', { href: '#' }, ->
        t.check sort == 'date', 'sort-by-due-date'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_cards_sort.coffee